import reduceReducers from "reduce-reducers";

import { BILLING_SETTINGS, DEPLOYMENT } from "constants/actionTypes";

import {
  apiModelOfflineFetchReducer,
  apiModelOfflineUpdateReducer,
} from "lib/reducers";
import { deserializeBillingSettings } from "lib/serializers/billingSettings";

const fetch = apiModelOfflineFetchReducer(BILLING_SETTINGS, {
  deserializer: deserializeBillingSettings,
  clearOnRequest: true,
});

/* 
Note - update is not currently used in the app - these are pushed up through the deployment endpoint, and pull down standalone. 
 */
const update = apiModelOfflineUpdateReducer(BILLING_SETTINGS, {
  deserializer: deserializeBillingSettings,
});

function deploymentReducer(state, action) {
  switch (action.type) {
    //   Don't rely on pusher to tell us we have updated our billing settings via the deployment endpoint.
    case DEPLOYMENT.UPDATE.REQUEST: {
      const { payload } = action;
      const { billing_settings: billingSettings } = payload;
      if (billingSettings && billingSettings.id) {
        return {
          ...state,
          byId: {
            ...state.byId,
            [billingSettings.id]: deserializeBillingSettings(billingSettings),
          },
        };
      }
      return state;
    }
    default:
      return state;
  }
}

const billingSettingsReducer = reduceReducers(fetch, update, deploymentReducer);

export default billingSettingsReducer;
